import type { UiKey } from './en';

export const de: Record<UiKey, string> = {
  'lang.label': 'Sprache',

  'nav.residences': 'Residenzen',
  'nav.mobility': 'Mobilität',
  'nav.retreats': 'Retreats',
  'nav.slClub': 'SL Club',
  'nav.privateLine': 'Private Line',
  'nav.membership': 'Mitgliedschaft',
  'nav.login': 'Anmelden',
  'nav.menu': 'Menü',
  'nav.closeMenu': 'Menü schließen',
  'nav.home': 'Superluxury — Startseite',

  'menu.clientLine': 'Direkte Linie',
  'menu.clientLineNote': 'Rund um die Uhr von einem Partner beantwortet.',

  'announcement.text': 'Private Beratungen empfangen wir ab sofort in unseren neuen Ateliers in Genf und Dubai.',
  'announcement.link': 'Ein privates Gespräch anfragen',
  'announcement.close': 'Hinweis schließen',

  'hero.label': 'Superluxury stellt sich vor',
  'hero.srTitle': 'Venturist — eine private Veranstaltungsreihe von Superluxury',
  'hero.tagline': 'Eine private Reihe von Superluxury. Nur auf Einladung.',
  'hero.discover': 'Venturist entdecken',
  'hero.scroll': 'Weiter scrollen',
  'hero.pause': 'Film pausieren',
  'hero.play': 'Film abspielen',

  'footer.help': 'Können wir helfen?',
  'footer.faq': 'Häufige Fragen',
  'footer.support': 'Support: Englisch',
  'footer.house': 'Das Haus',
  'footer.locator': 'Atelier finden',
  'footer.locatorPlaceholder': 'LAND/REGION, STADT',
  'footer.findAtelier': 'Atelier finden',
  'footer.lettersTitle': 'Superluxury Letters abonnieren',
  'footer.lettersBody':
    'Erhalten Sie exklusive Notizen zu neuen Leistungen, persönliche Einladungen und weitere Neuigkeiten aus der Welt von Superluxury.',
  'footer.lettersThanks': 'Vielen Dank. Sie erhalten den nächsten Brief.',
  'footer.email': 'E-Mail',
  'footer.signUp': 'Abonnieren',
  'footer.emailError': 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
  'footer.country': 'Land/Region',
  'footer.services': 'Superluxury Leistungen',
  'footer.discoverServices': 'Unsere Leistungen entdecken',
  'footer.seekIntro': 'Um eine Vorstellung bitten',
  'footer.destinations': 'Destinationen',
  'footer.follow': 'Folgen Sie uns',
  'footer.rights': 'Alle Rechte vorbehalten.',
};
